import { isRouteErrorResponse, useRouteError } from 'react-router';

import { ApiError } from '../api/errors';
import { ErrorScreen } from './ErrorScreen';

/** Describes an unexpected error for the development-only technical detail block. */
export function describeError(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    return `${String(error.status)} ${error.statusText}`;
  }
  if (error instanceof ApiError) {
    // The correlation ID is what to search for in the backend's or the agent's logs
    // (`api/errors.ts`) - worth keeping even where `error.stack` would otherwise win below.
    const stack = error.stack ?? error.message;
    return error.correlationId === undefined
      ? stack
      : `${stack}\ncorrelation-id: ${error.correlationId}`;
  }
  if (error instanceof Error) {
    return error.stack ?? error.message;
  }
  return String(error);
}

/** Router error boundary: renders the shared Spanish error state for any route failure. */
export function RouteErrorScreen() {
  const error = useRouteError();
  return (
    <ErrorScreen
      detail={describeError(error)}
      onRetry={() => {
        window.location.reload();
      }}
    />
  );
}
